export default {
      id: "report-pin-usage",
      viewBox: "0 0 9 14",
      url: __webpack_public_path__ + "sprite-46b249.svg#report-pin-usage",
      toString: function () {
        return this.url;
      }
    }